module.exports = __webpack_public_path__ + "static/headshot-chris-long-3x.e19ac6e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-chris-long-3x.jpg
// module id = 121
// module chunks = 35783957827783 152909308826437